"use client";

import { c as _c } from "react/compiler-runtime";
import { useParams, usePathname, useRouter, useSearchParams } from "next/navigation";
import { filterTypes } from "../types/filter";
export const LANG_LABELS: Record<string, string> = {
  cs: "Česky",
  de: "Deutsch",
  en: "English",
  es: "Español",
  fr: "Français",
  hu: "Magyar",
  it: "Italiano",
  pt: "Português do Brasil",
  ro: "Română",
  sv: "Svenska",
  nl: "Nederlands",
  pl: "Polski",
  // NOTE: there are two keys for chinese
  zh: "中文",
  cn: "中文",
  tw: "台灣國語"
};

/**
 * List of filter parameter names that should be removed when changing language
 */
const FILTER_PARAM_NAMES = new Set<string>(Object.values(filterTypes));

/**
 * Removes filter parameters from URL search params while preserving
 * tracking and other non-filter parameters
 */
function removeFilterParams(searchParams: URLSearchParams): URLSearchParams {
  const newParams = new URLSearchParams();

  // Keep all parameters that are NOT filter parameters
  searchParams.forEach((value, key) => {
    if (!FILTER_PARAM_NAMES.has(key as string)) {
      newParams.append(key, value);
    }
  });
  return newParams;
}
export function useLanguageSwitch() {
  const $ = _c(7);
  const {
    locale
  } = useParams();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== pathname || $[1] !== router || $[2] !== searchParams) {
    t0 = function onValueChange(loc) {
      const segments = pathname.split("/");
      segments[1] = loc;
      const paramsWithoutFilters = removeFilterParams(searchParams);
      const queryString = paramsWithoutFilters.toString();
      const url = queryString ? `${segments.join("/")}?${queryString}` : segments.join("/");
      router.replace(url);
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = searchParams;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const onValueChange = t0;
  const t1 = locale as string;
  let t2;
  if ($[4] !== onValueChange || $[5] !== t1) {
    t2 = {
      value: t1,
      onValueChange
    };
    $[4] = onValueChange;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}